// Profession service for managing profession guides
import { app } from '../firebase';
import { 
  getFirestore, 
  collection, 
  doc, 
  getDoc,
  getDocs, 
  updateDoc,
  setDoc,
  serverTimestamp
} from 'firebase/firestore';

const db = getFirestore(app);

export interface ProfessionGuide {
  id: string;
  professionId: string;
  content: string; // Markdown content
  updatedAt: any; // Firestore timestamp
  updatedBy?: string; // User ID who last updated
}

/**
 * Get a profession guide by profession ID
 */
export async function getProfessionGuide(professionId: string): Promise<ProfessionGuide | null> {
  try {
    const docRef = doc(db, 'profession_guides', professionId);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data()
      } as ProfessionGuide;
    }
    
    return null;
  } catch (error) {
    console.error('Error getting profession guide:', error);
    return null;
  }
}

/**
 * Save or update a profession guide
 */
export async function saveProfessionGuide(
  professionId: string,
  content: string,
  userId: string
): Promise<string | null> {
  try {
    const docRef = doc(db, 'profession_guides', professionId);
    await setDoc(docRef, {
      professionId,
      content,
      updatedAt: serverTimestamp(),
      updatedBy: userId
    }, { merge: true });
    
    return null; // Success
  } catch (error) {
    console.error('Error saving profession guide:', error);
    return 'Failed to save profession guide';
  }
}

/**
 * Get all profession guides (for admin overview)
 */
export async function getAllProfessionGuides(): Promise<ProfessionGuide[]> {
  try {
    const querySnapshot = await getDocs(collection(db, 'profession_guides'));
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    } as ProfessionGuide));
  } catch (error) {
    console.error('Error getting all profession guides:', error);
    return [];
  }
}























